import React from 'react';
import IntroAppUI from './IntroApp.presenter';

function IntroApp() {
    return <IntroAppUI />;
}

export default IntroApp;
